import React from "react";
import "../assets/Styles/about.css"
import "../assets/Styles/Allfonts.css";
import polygon2 from "../assets/img/Polygon2.svg"
import polygon from "../assets/img/Polygon.svg"




const Policy = () => {
    return (

        <div className="About us container-fluid g-0">
            <div className="d-flex justify-content-center align-items-center about text-white backIcon">
                <h1 className="allFonts">Privacy policy</h1>
            </div>
            <div className="container mt-4 mb-5 policy">
                <p>This Privacy Policy was last modified on September 1, 2023.</p>

                <p>
                    We, sportsnerve solutions pte. ltd. (“we”, “us”, “our”), are the owners of sportsnerve sportsnerve.com and mobile application (“application” or “app”). unless otherwise set out below, each capitalized terms in this privacy policy shall have the meaning as set out in the terms of service of the app.

                </p>

                <p>
                    we respect data privacy rights and are committed to protecting personal information collected on this app. this privacy policy (“privacy policy”) sets forth how we collect, use and protect the personal information collected on this app.
                </p>

                <p>
                    please read this privacy policy carefully. by continuing to use the app, providing us personal information, you consent to our use of your personal information in accordance with the terms of this privacy policy. if you do not agree to this privacy policy, you may withdraw your consent or alternatively choose not to provide your personal information on the app. such an intimation to withdraw your consent can be provided by email to contact@spotsnerve.com.
                </p>

                <p>
                    if you are accessing the app on behalf of a third party, you represent that you have the authority to bind such third-party to the terms and conditions of this privacy policy and, in such an event your use of the app shall refer to use by such third party. if you do not have such an authority (to provide any personal information of a third party) or do not agree to the terms of this privacy policy, then you should refrain from using the app.
                    this privacy policy is an electronic record in the form of an electronic contract being compliant and construed in accordance with data protection laws of the jurisdictions where we have our presence.
                </p>


                <h2>Definitions</h2>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p>You can lawfully enter into and form contracts as per the applicable laws and that you are fully able, competent and authorized to enter into the terms, conditions, obligations, representations and warranties set forth in these TERMS.  </p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p>“Personal Information” shall mean any information (such as name, email address, company name, address, phone number, location, date of birth, gender, etc.) provided by you or collected by us, as a result of your use / access of the Application, that can identify you as a person.</p>
                </div>


                <h2>What Information do we collect?</h2>

                <p>We may collect and receive user information and other information in various ways when you use our Application. This Privacy Policy covers how we treat Personal Information that we gather when you access or use our Application. This Privacy Policy does not cover the practices of companies we do not own or control or people we do not manage. We may process Personal Information of our Users in connection with our provision of certain services to our Users.</p>


                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> <b>Personal Information collected when you contact us:</b> We may collect your Personal Information such as name, email address and role from you when you contact us or write to us on our email address or provide us feedback or other interactions through the App.</p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p><b>Registration and Verification of User Account:</b> While signing up for the Application, you would need to provide certain Personal Information such as your profile picture, name, nickname, address, email address, date of birth, gender and location. Furthermore, your email address is collected and used for verification of the account. </p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> <b>Registering of Family Members:</b> Any User who registers any family members on the Application, the Personal Information of that family member, including name, date of birth, image, gender and relationship, may be collected, stored and used by us. </p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> <b>Team Creation:</b> For the purpose of creating teams which constitute many members, we may collect Personal Information like team name, sports type, country/city/state, etc. A user may also be allowed to manually add members by entering certain Personal Information of that individual such as name, email address, phone number. Further, all members in a team may provide and fill in information such as personal background, jersey details, expectations from the team. This non-personally identifiable information is also collected and are visible to other members in that particular team. </p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p><b>Event Creation:</b> This function allows for creating events, in which multiple teams can participate and also has chat groups for each event. We may collect, store and use any such information which is being shared on the chat groups. </p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> <b>Admin Details:</b> For hosting of training sessions on the Application, facility admins (“Admins”) may  register themselves by providing details such as company name, name of Admin, email address and phone number.</p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> <b>Coach Details:</b> We may collect, store and use Personal Information of coaches registered on the Application (“Coach”) such as name, phone number, email address, background of the Coach. A coach can get registered only when a facility registers him/her. Therefore, certain non-personal information may also be collected and stored such as training name, facility name, curriculum and age group. </p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> <b>Uploading Proof of Payment:</b> On incurring any expenses, users, who have incurred such expenses, may upload the receipts thereof, on the Application, as proof of payment. This information will be collected, stored and displayed and disseminated to other members of the team, in order to alert them regarding payment of their share of the expenses. </p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> <b> Analysis of Performance of User:</b> We may also collect, store and use information regarding the feedback given to users in order to provide them with a comprehensive analysis of their performance and progress. This data will be recorded in the Application. </p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> <b>Payment Information:</b> You may elect to pay for the Services through our App, we may collect certain information such as name and email address to process your request. You will be required to provide certain payment information directly to our payment processing partners, including but not limited to your name, credit/debit card information. We do not access, store or collect your credit/debit card information.</p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> <b>Log Data:</b> When you visit the App, whether or not you have logged-in, our servers automatically record information that your device sends whenever you visit the App ("Log Data"). This Log Data may include information such as your device’s Internet Protocol ("IP") address, pages of our App that you use, the time spent on the App, information you search for on our App, access times and dates, and other analytical data.</p>
                </div>
                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> <b>Social Media Handles:</b> If you subscribe to our blog, newsletters or contact us through social media Apps such as LinkedIn, Facebook, Twitter etc. (“Social Media”), we may get access to your Personal Information on such Social Media (such as your name, email id, and phone).</p>
                </div>



                <h2>Cookies</h2>
                <p>We use cookies and/or similar in-house and third-party tracking tools to track user traffic patterns. Tracking tools also used are beacons, tags and scripts to collect and track information and to improve and analyze our website, App and our services. You may choose to disable cookies through your browser settings. For more information, please refer to our cookie policy at sportsnerve.com.</p>

                <h2>Accuracy of Information</h2>
                <p>Please ensure that any Personal Information you provide to us is accurate and up to date information. If you are sharing any Personal Information on behalf of a third person, you should ensure that you are authorised to do so.</p>

                <h2>What do we do with your Personal Information?</h2>

                <p>We use the Personal Information for the following purposes: </p>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> To enable verification of your account on the Application.</p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> For creation or development of business intelligence or data analytics in relation to our Application and/or Services provided by us.</p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> To provide you with information about our Services and/or periodic newsletters.</p>
                </div>


                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p>To assess queries, requirements, and process requests for services.  </p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> For facilitating selection of members in teams and assisting with team management.</p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> To improve the usability of the Application </p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p>For customer communication.  </p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> To enhance security of the Application.</p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p>To comply with our legal and statutory obligations.  </p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p>For internal record keeping.  </p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> To run marketing or promotional campaigns. </p>
                </div>


                <h2>Disclosure of Personal Information </h2>

                <p>We do not sell, rent, share, distribute, lease, or otherwise provide your Personal Information to third parties, without your prior consent. Keeping this in mind, we may disclose your Personal Information in the following cases:</p>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> De-identified information: We reserve the right to share demographic information about our users and traffic to our partners and advertisers. We will not share any of your personal information or any data that you store using our services to any third party except as set out in this Privacy Policy. </p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p>Service Providers: We may disclose your Personal Information with the service providers who work with us in connection with operating and maintaining the Application and/or providing the Services.  </p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p>Mergers or Acquisitions: We may transfer your Personal Information if we are acquired by another entity, or if we merge with another company or transfer a part of our business, including the Application, to a third party. Any such third part or resultant entity that receives your Personal Information shall have the right to continue to use your Personal Information in line with the purposes set out herein.  </p>
                </div>
                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> Compliance with Laws: We may disclose your information to a third party as required by law when we believe in good faith that such disclosure is required: (a) by law; (b) to comply with legal process or governmental requests; (c) to enforce our agreements; (d) to protect our operations; (e) to protect our rights, privacy, safety or property; and (f) to permit us to pursue available remedies or limit the damages that we may sustain.</p>
                </div>

                <h2>Data Retention </h2>

                <p>We will retain users’ Personal Information as long as it is required to be retained for the purpose of provision of the Services on our Application. The duration for which Personal Information is retained, and criteria for determining that time, are dependent on the nature of the Personal Information and the purpose for which it was provided/collected.

                </p>

                <p>Subject to this section, we will endeavour to erase/delete your Personal Information upon reasonable written request for the same. Please note, however, that there might be a latency in deleting Personal Information from our servers and backed-up versions might exist even after deletion. For more information on where and how long your personal information is stored, and for more information on your rights of erasure and portability, please contact contact@spotsnerve.com.</p>

                <h2>Security </h2>

                <p>We are committed to maintaining information security and protecting user data from potential breaches. Although we do provide firewalls and protections, we cannot warrant the security of Personal Information transmitted as these systems are not hack proof. Data pilferage due to unauthorized hacking, virus attacks, technical issues is possible, and we will take necessary measures to mitigate such events. You are required to be careful to avoid “phishing” scams, where someone may send you an e-mail that looks like it is form us asking for your Personal Information.

                </p>

                <p>You agree to immediately notify us in writing in case of any unauthorised use of your login or any other breach of security.</p>

                <h2>Information for EU/EEA and UK Users  </h2>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> <b>Applicability of GDPR:</b> Residents of European Union (“EU”) and United Kingdom (“UK”) should note that this Privacy Policy has been updated in accordance with the requirements of the EU General Data Protection Regulation (the “GDPR”) and the UK GDPR, the United Kingdom Data Protection Act 2018, the Privacy and Electronic Communications Regulations and any regulation superseding any of the foregoing (“UK Privacy Laws”). As per provisions of the GDPR and UK Privacy Laws, we shall be considered the Controllers of Personal Information collected as a result of your use/access of the Application. </p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p>  <b>Legal Basis (For EU and UK residents):</b> We will not process your Personal Information without a lawful basis to do so. We will process your Personal Information only on the legal bases of consent, contract, or on the basis of our legitimate interests, provided that such interests are not overridden by your privacy rights and interests.</p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> <b>Transfer of your Personal Information across borders (for EU residents):</b> We have a worldwide presence. The Personal Information we collect (of EU and UK residents) might be processed outside the EU at a secure centre. We collect and transfer Personal Information outside the EU in accordance with the provisions of the GDPR and UK Privacy Laws.  </p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> <b>Your Rights:</b> You have the right to request us to let you know what Personal Information belonging to you do we hold in our possession, right to withdraw consent at any time where we are relying on consent to process your Personal Information, right to have us rectify or modify any such Personal Information, right to have us erase/delete your Personal Information, right to restrict us from processing such Personal Information, right to object to our use of your Personal Information and you have the right to lodge a complaint with a data protection authority.

                    </p>



                </div>

                <p>UK residents have the right to make a complaint at any time to the Information Commissioner’s Office (“ICO”), the UK supervisory authority for data protection issues ( <a href="https://ico.org.uk/" about="_blank" >www.ico.org.uk</a> ). We would, however, appreciate the chance to deal with your concerns before you approach the ICO so please contact us in the first instance. We may need to request specific information from you to help us confirm your identity or also contact you for further information in relation to your request. If you would like to exercise ANY of these rights, please contact <a href="mailto:contact@spotsnerve.com?subject=Question&body=Hello,">contact@spotsnerve.com</a> .</p>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> <b>Governing Laws:</b> For any EU and UK residents, this Privacy Policy shall be governed by the provisions of the GDPR and UK Privacy Laws.  </p>
                </div>

                <h2>Information about Singapore Users </h2>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> <b>Applicability of PDPA:</b> This Privacy Policy is subject to the Singapore Personal Data Protection Act (No 26 of 2012) “PDPA”. </p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> <b>Withdrawal of Consent:</b> As per the PDPA upon reasonable notice given by you about the withdrawal of your consent given or deemed to be given with respect to the collection, use or disclosure of withdrawing this consent and will cease (and cause any of our data intermediaries and agents to cease) collecting, using or disclosing the Personal Information, unless it is required or authorized under applicable laws.  </p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> <b>Accuracy of Personal Information:</b> We will take reasonable efforts to ensure that Personal Information collected by us or on our behalf is accurate and complete.  </p>
                </div>


                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> <b>Transfer of your Personal Information outside of Singapore:</b> We will ensure that the transfer of your Personal Information is as per the requirements of PDPA. </p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> <b>Inquiries:</b> If you have any concerns, enquiries or complaints related to your Personal Information. Please contact us at contact@spotsnerve.com.  </p>
                </div>

                <h2>Information about California Users </h2>

                <p>If you are a California resident, you have the rights outlined in this section. If you are a California resident and there are conflicts between this section and any other provision of this Privacy Policy, the portion that is more protective of your Personal Information shall control. </p>


                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> <b>Access:</b> You have the right to request certain information about our collection and use of your Personal Data over the past 12 months. We will provide you with the following information: </p>
                </div>

                <div className="d-flex polygon2 ">
                    <img src={polygon2} alt="" />
                    <p> The categories of Personal Information that we have collected about you.</p>
                </div>

                <div className="d-flex polygon2 ">
                    <img src={polygon2} alt="" />
                    <p> The categories of sources from which that Personal Information was collected.</p>
                </div>
                <div className="d-flex polygon2 ">
                    <img src={polygon2} alt="" />
                    <p>The business or commercial purpose for collecting or selling your Personal Information; </p>
                </div>

                <div className="d-flex polygon2 ">
                    <img src={polygon2} alt="" />
                    <p>The categories of third parties with whom we have shared your Personal Information; and </p>
                </div>


                <div className="d-flex polygon2 ">
                    <img src={polygon2} alt="" />
                    <p> The specific pieces of Personal Information that we have collected about you.</p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> <b>Deletion:</b> You have the right to request that we delete the Personal Data that we have collected from you. Under the California Consumer Privacy Act of 2018 (“CCPA”), this right is subject to certain exceptions. For example, we may need to retain your Personal Data to provide you with the Services or complete a transaction or other action you have requested. If your deletion request is subject to one of these exceptions, we may deny your deletion request. </p>
                </div>

                <div className="d-flex polygon ">
                    <img src={polygon} alt="polygon" />
                    <p> <b>Exercising Your Right:</b> To exercise the rights described above, you must send us a request that (1) provides sufficient information to allow us to verify that you are the person about whom we have collected Personal Data (this will require you to send an email from the account in question or login credentials), and (2) describes your request in sufficient detail to allow us to understand, evaluate, and respond to it. Each request that meets both of these criteria will be considered a “Valid Request.” We may not respond to requests that do not meet these criteria. </p>
                </div>


                <p>We will only use Personal Data provided in a Valid Request to verify you and complete your request. You do not need an account to submit a Valid Request.
                    We will work to respond to your Valid Request within 45 days of receipt. We will not charge you a fee for making a Valid Request unless your Valid Request(s) is excessive, repetitive, or manifestly unfounded. If we determine that your Valid Request warrants a fee, we will notify you of the fee and explain that decision before completing your request.



                </p>

                <p>
                    You may submit a Valid Request by emailing contact@spotsnerve.com.

                </p>
                <p>
                    You may also authorize an agent (an “Authorized Agent”) to exercise your rights on your behalf. To do this, you must provide your Authorized Agent with written permission to do, and we may request a copy of this written permission from your Authorized Agent when they make a request to exercise your rights on your behalf.
                </p>

                <p><b>We Will Not Discriminate Against You for Exercising Your Rights Under the CCPA</b></p>

                <p>We will not discriminate against you for exercising your rights under the CCPA. We will not deny you our services, charge you different prices or rates, or provide you a lower quality services if you exercise your rights under the CCPA. However, we may offer different tiers of our services as allowed by applicable data privacy laws (including the CCPA) with varying prices, rates, or levels of quality of the services you receive related to the value of Personal Information that we receive from you.</p>

                <h2>Childrens Privacy </h2>

                <p>We do not knowingly collect Personal Information from children under the age of 18 years without the prior, verifiable consent of his or her legal representative. If you are a child under the age of 18 years, please do not provide any Personal Information. If the legal representative of the child discovers that the child has provided us with Personal Information, we request the legal representative of the child to contact us contact@sportsnerve.com to have the Personal Information deleted.</p>

                <h2>Choice and Opt-Out </h2>

                <p>We may send you communications including but not limited to: (a) notices about your use of our Application and services provided thereto, including those concerning violations of use; (b) updates; (c) promotional information regarding out services; and (d) newsletters. You may opt out of receiving promotional emails and newsletters from us by following the unsubscribe instructions provided in those emails. Alternatively, you can opt out, at any time, by emailing contact@spotsnerve.com with your specific request. </p>

                <h2>Limitation of Liability</h2>

                <p>To the extent permissible under the law, we shall not be liable for any direct, indirect, incidental, special, consequential, or exemplary damages, including but not limited to, damages for loss of profits, goodwill, data, information, or other intangible losses (even if we have been advised of the possibility of such damages), arising out of this Privacy Policy. </p>

                <h2>
                Governing Laws and Disputes
                </h2>

                <p>This Privacy Policy shall in all respects be governed by and construed and enforced in accordance with the laws of Singapore and the courts in Singapore shall have exclusive jurisdiction to adjudicate any subject matter arising out of this Privacy Policy. </p>

                <h2>Changes to this Policy</h2>

                <p>We may update this Privacy Policy from time to time. You are encouraged to check this Privacy Policy on a regular basis to be aware of the changes made to it. </p>

                <h2>Contact Us</h2>
                <p>If you have any questions or concerns or grievances regarding this Privacy Policy, you can reach out  at contact@spotsnerve.com</p>


            </div>


        </div>

    )
}

export default Policy;